import { LoyaltyRewardMiniCardPropsWithId } from "components/molecules/LoyaltyRewardMiniCard/types";

export const LISTS_REWARDS = (data: {
  cashback: LoyaltyRewardMiniCardPropsWithId[];
  freeSpins: LoyaltyRewardMiniCardPropsWithId[];
  nominals: LoyaltyRewardMiniCardPropsWithId[];
}) => [
  {
    key: "nominals",
    title: "loyalty.redesign.1.title.cash-bonus",
    list: data.nominals,
    tooltip: "loyalty.redesign.1.tooltip.nominal",
  },
  {
    key: "cashback",
    title: "loyalty.redesign.1.title.cashback",
    list: data.cashback,
    tooltip: "loyalty.redesign.1.tooltip.cashback",
  },
  {
    key: "freeSpins",
    title: "loyalty.redesign.1.title.freeSpins",
    list: data.freeSpins,
    tooltip: "loyalty.redesign.1.tooltip.freespins",
  },
];
